import { StatusController } from './status.controller';
import template from './status.html';

export const statusComponent = {
  name: 'statusComponent',
  restrict: 'E',
  template,
  controller: StatusController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/status/status.component.js